/**
 * Target ids for the manager cockpit tour, kept apart from the single-partner ones: components
 * both cockpits render take their id as a prop from the cockpit rendering them, so the two tours
 * never share a name.
 *
 * As on the partner board, a maximized tile leaves its grid copy mounted at `opacity: 0`, so each
 * copy carries its own id and the board tiles are only spotlightable once every tile is collapsed.
 */
export const MANAGER_COCKPIT_TOUR_TARGETS = {
  sectionRail: 'manager-cockpit-section-rail',
  filterPanel: 'manager-cockpit-filter-panel',
  filterRtm: 'manager-cockpit-filter-rtm',
  filterOptions: 'manager-cockpit-filter-options',
  scopePanel: 'manager-cockpit-scope-panel',
  scopeBar: 'manager-cockpit-scope-bar',
  scopeFiscalYear: 'manager-cockpit-scope-fiscal-year',
  statusCompleteness: 'manager-cockpit-status-completeness',
  statusAcknowledgment: 'manager-cockpit-status-acknowledgment',
  statusPlanQuality: 'manager-cockpit-status-plan-quality',
  scopePeriod: 'manager-cockpit-scope-period',
  scopeMetric: 'manager-cockpit-scope-metric',
  scopeCurrency: 'manager-cockpit-scope-currency',
  trainingCentre: 'manager-cockpit-training-centre',
  programmeTabs: 'manager-cockpit-programme-tabs',
  categoryChip: 'manager-cockpit-category-chip',
  tileRevenue: 'manager-cockpit-tile-revenue',
  tileRevenueExpanded: 'manager-cockpit-tile-revenue-expanded',
  revenueViewSwitch: 'manager-cockpit-revenue-view-switch',
  tileInitiatives: 'manager-cockpit-tile-initiatives',
  tileInitiativesExpanded: 'manager-cockpit-tile-initiatives-expanded',
  initiativesViewSwitch: 'manager-cockpit-initiatives-view-switch',
  tileAttention: 'manager-cockpit-tile-attention',
  tileAttentionExpanded: 'manager-cockpit-tile-attention-expanded',
  tileDocuments: 'manager-cockpit-tile-documents',
  tileDocumentsExpanded: 'manager-cockpit-tile-documents-expanded',
} as const
